export default __webpack_public_path__ + "static/media/fast-ci.3073e642.png";